<template>
    <div class="notification-title">
        <p>Notificações
        </p>
    </div>
    <div 
        class="notification-item" 
        v-for="notification in limitedNotifications" 
        :key="notification.id"
        @click="redirectToInquiries"
        :class="{ unread: notification.isRead == 0 }"
    >
        <div class="notification-info">
            <div class="notification-header">
                <span class="notification-title-text">{{ notification.title }}</span>
                <span class="notification-dot" v-if="notification.isRead == 0"></span>
            </div>
            <div class="notification-description" v-html="textoComEllipsis(notification.description)"></div>
        </div>
    </div>
    <div v-if="limitedNotifications.length === 0" class="no-notifications">
        <p>Nenhuma notificação não lida</p>
    </div>
    <div class="notification-action" >
        <button @click="redirectToInquiries">Ver todas as notificações</button>
    </div>
</template>

<script>
import api from '@/utils/portal/notification.js';
import { mapState } from 'vuex';

export default {
    props: {
        title: {
            type: String,
            required: true
        },
        data: {
            type: Array,
            required: true
        }
    },
    computed: {
        ...mapState(['token']),
        limitedNotifications() {
            if (!this.data || this.data.length === 0) {
                console.log('Nenhum dado de notificação disponível');
                return [];
            }
            
            // Filtrar apenas notificações não lidas (isRead: 0) e pegar as primeiras 2
            const unreadNotifications = this.data.filter(notification => notification.isRead === 0);
            const limitedResult = unreadNotifications.slice(0, 2);
            console.log('Notificações não lidas:', limitedResult);
            return limitedResult;
        }
    },
    methods: {
        redirectToInquiries() {
            window.location = '/aluno/notificacoes';
        },
        async updateUnreadCount() {
            try {
                const response = await api.getNumberNotifications(this.token);
                // Emitir evento para o componente pai atualizar o contador
                this.$emit('unread-count-updated', response);
            } catch (error) {
                console.error('Erro ao atualizar contador de notificações:', error);
            }
        },
        formatDate(dateString) {
            if (!dateString || dateString === null) return 'Data não disponível';
            
            const date = new Date(dateString);
            
            // Verificar se a data é válida
            if (isNaN(date.getTime())) {
                return 'Data inválida';
            }
            
            const now = new Date();
            const diffInMs = now - date;
            const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
            const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
            const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
            
            if (diffInMinutes < 1) {
                return 'Agora mesmo';
            } else if (diffInMinutes < 60) {
                return `${diffInMinutes} min atrás`;
            } else if (diffInHours < 24) {
                return `${diffInHours}h atrás`;
            } else if (diffInDays === 1) {
                return 'Ontem';
            } else if (diffInDays < 7) {
                return `${diffInDays} dias atrás`;
            } else {
                return date.toLocaleDateString('pt-BR', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                });
            }
        },
        textoComEllipsis(text) {
            if (!text) return '';
            if (text.length > 80) {
                return text.substring(0, 80) + "...";
            } else {
                return text;
            }
        }
    },
    mounted() {
        console.log('Notifications.vue montado, dados recebidos:', this.data);
        // Verificar se há notificações não lidas e atualizar contador
        this.updateUnreadCount();
        
        // Escutar evento customizado de notificação lida
        window.addEventListener('notification-read', this.updateUnreadCount);
    },
    watch: {
        data: {
            handler(newData) {
                console.log('Dados de notificação alterados no Notifications.vue:', newData);
            },
            immediate: true,
            deep: true
        }
    },
    beforeUnmount() {
        // Remover listener ao desmontar o componente
        window.removeEventListener('notification-read', this.updateUnreadCount);
    }
}
</script>

<style scoped>
.notification-title {
    border-bottom: 1px solid #e3e3e3;
    padding: 12px 16px;
    background: #fafbfc;
    text-align: left;
}
.dark .notification-title {
    border-bottom:1px solid #494949;
    padding: 12px 16px;
    background: #181818 !important;
    text-align: left;
    color: #fff !important;
}
.notification-title p {
    margin: 0;
    font-size: 15px;
    color: #555;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-align: left;
}

.notification-item {
    background: #fff;
    border-bottom: 1px solid #f0f0f0;
    padding: 14px 16px;
    cursor: pointer;
    transition: background 0.2s;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    text-align: left;
}
.dark .notification-item {
    background: #181818 !important;
    border-bottom: 1px solid #f0f0f0 !important;
    padding: 14px 16px !important;
    cursor: pointer;
    transition: background 0.2s;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    text-align: left;
}
.dark .notification-item {
    background: #181818 !important;
    border-bottom: 1px solid #272727 !important;
    padding: 14px 16px;
    cursor: pointer !important;
    transition: background 0.2s !important;
    display: flex !important;
    justify-content: flex-start;
    align-items: flex-start;
    text-align: left;
}
.notification-item.unread {
    background: #f5fcfd;
}
.notification-item:hover {
    background: #f0f8fa;
}

.notification-info {
    width: 100%;
    text-align: left;
}

.notification-header {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    text-align: left;
}

.notification-title-text {
    font-size: 15px;
    font-weight: 600;
    color: #222;
    margin-right: 8px;
    line-height: 1.2;
    text-align: left;
}

.notification-dot {
    display: inline-block;
    background: #19c7d0;
    height: 8px;
    width: 8px;
    border-radius: 50%;
    margin-left: 4px;
}

.notification-description {
    font-size: 14px;
    color: #444;
    margin-top: 4px;
    margin-bottom: 6px;
    line-height: 1.4;
    word-break: break-word;
    text-align: left;
}
.dark .notification-description {
    font-size: 14px;
    color: #fff !important;
    margin-top: 4px;
    margin-bottom: 6px;
    line-height: 1.4;
    word-break: break-word;
    text-align: left;
}

.notification-date {
    font-size: 12px;
    color: #888;
    margin-top: 2px;
    text-align: left;
}

.notification-action {
    padding: 12px 0 8px 16px;
    background: #fafbfc;
    border-top: 1px solid #e3e3e3;
}
.dark .notification-action {
    background: #181818 !important;
    border-top: 1px solid #272727 !important;
}
.dark .notification-action button {
    color: #19c7d0 !important;
}
.notification-action button {
    background: none;
    border: none;
    color: #19c7d0;
    font-weight: 700;
    font-size: 14px;
    cursor: pointer;
    padding: 6px 16px;
    border-radius: 4px;
    transition: background 0.2s;
    text-align: left;
}
.notification-action button:hover {
    background: #e6f7fa;
}

.no-notifications {
    padding: 20px 16px;
    text-align: center;
    color: #666;
    font-style: italic;
}

.dark .no-notifications {
    color: #999;
}
</style>

<style>
.global_header.dark .notification_bar.show {
    background-color: #181818;
    border-color: #494949;
}
.global_header.dark .notification_bar.show p,
.global_header.dark .notification_bar.show span {
    color: #f5f5f5;
}
.notification_bar .notification-title p {
    color: #242424 !important;
}
.dark .notification_bar .notification-title p {
    color: #fff !important;
}
</style>